import type {Fee} from "@/types/Fee.ts";

export const PAID = "paid";
export const DUE = "due";
export const PARTIAL = "partial";

export type AssessedFee = {
    id: string;
    dateAssessed: string;
    assessedFinancialAid: string;
    assessedCost: number;
    status: typeof PAID | typeof DUE | typeof PARTIAL;
    notes: string;
    waived: boolean;
    shouldDelete: boolean;
    rolledOver: boolean;
    overrideCost: number;
    selfAssessed: boolean;
    allowPartialPayment: boolean;
    fee: Fee;
    courseAnswer?: CourseAnswer[];
    studentFeePayments: FeePayment[];
};

export type FeePayment = {
    id: string;
    cost: number;
    paymentType: string | null;
    paymentTypeDetail: string | null;
    createdAt: string;
    glenbrookPaymentId?: number | null;
};

export type CourseAnswer = {
    id: string;
    cachedQuestion: string;
    questionID: string;
    answer?: string;
    responseType: string;
};
